import { render, staticRenderFns } from "./cm_detail.vue?vue&type=template&id=36b010a6&scoped=true"
import script from "./cm_detail.vue?vue&type=script&lang=js"
export * from "./cm_detail.vue?vue&type=script&lang=js"
import style0 from "./cm_detail.vue?vue&type=style&index=0&id=36b010a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b010a6",
  null
  
)

export default component.exports